import React from "react";
import "./index.css";
function TermsConditions() {
  return (
    <section class="event1 event2 ">
      <div class="container termsContainer">
        <div class="eventHead aosAnim">
          <h3 class="titleText">Terms & Conditions</h3>
          <p>
            <strong>Last Updated on:</strong> 15th Jan 2026
          </p>

          <ol>
            <li>
              <h2>Preliminary</h2>
              <ol>
                <li>
                  These terms of use (“Terms”) are being entered into between
                  the user (“User” or “You” or “Your”) and Biz Hero India
                  Private Limit (“Now Purchase” or “Us” or “We” or “Our”) and
                  form a legally binding contract between You and Us. The Terms
                  apply to Your use of the Platform and for availing any
                  Services (defined below) from Us.
                </li>
                <li>
                  You agree that by accessing the website
                  &lt;nowpurchase.com&gt; (“Site”), You have read, understood,
                  and agree to be bound by all of these Terms. If You do not
                  agree with all of these Terms, then You are expressly
                  prohibited from using the Site and You must discontinue Your
                  use of the Platform and Services immediately.
                </li>
                <li>
                  This document is an electronic record in terms of Applicable
                  Laws including the Information Technology Act, 2000, and does
                  not require physical or digital signatures.
                </li>
                <li>
                  Supplemental terms or policies posted on the Site are
                  incorporated herein by reference. Now Purchase reserves the
                  right to modify these Terms.
                </li>
                <li>
                  Changes will be indicated by updating the “Last Updated” date.
                  Continued use constitutes acceptance.
                </li>
                <li>
                  You are responsible for periodically reviewing these Terms.
                </li>
                <li>
                  By registering on behalf of an organization, You confirm You
                  have authority to bind such organization.
                </li>
                <li>
                  Capitalized terms not defined herein shall have meanings
                  assigned in Section 2.
                </li>
              </ol>
            </li>

            <li>
              <h2>Definitions</h2>
              <ol>
                <li>
                  <strong>Account</strong> means the account created by the User
                  on the Platform.
                </li>
                <li>
                  <strong>Applicable Laws</strong> means all applicable
                  statutes, rules, regulations, and governmental orders.
                </li>
                <li>
                  <strong>Force Majeure</strong> means events beyond reasonable
                  control including natural disasters, war, cyber-attacks, or
                  legal changes.
                </li>
                <li>
                  <strong>Intellectual Property</strong> includes all
                  proprietary rights whether registered or unregistered.
                </li>
                <li>
                  <strong>Party</strong> refers individually to the User or Now
                  Purchase.
                </li>
                <li>
                  <strong>Platform / MetalCloud</strong> refers to Now
                  Purchase’s proprietary cloud-based solution.
                </li>
                <li>
                  <strong>Services</strong> means services provided through the
                  Platform.
                </li>
                <li>
                  <strong>User</strong> means any registered entity or
                  individual availing the Services.
                </li>
              </ol>
            </li>

            <li>
              <h2>Services</h2>
              <p>
                Now Purchase provides Services on MetalCloud. Certain Services
                may use Artificial Intelligence.
              </p>
              <ol>
                <li>
                  <strong>Commodity Purchase</strong>
                  <ol>
                    <li>Prices are not guaranteed.</li>
                    <li>Prices may change without notice.</li>
                    <li>Prices are not offers for sale.</li>
                  </ol>
                </li>
                <li>
                  <strong>Charge Mix Module</strong>
                  <ol>
                    <li>Based on theoretical models and assumptions.</li>
                    <li>Results may vary due to real-world factors.</li>
                    <li>Recommendations are auto-generated.</li>
                    <li>No responsibility for misuse or deviation.</li>
                  </ol>
                </li>
                <li>
                  <strong>Spectrometer Integration</strong>
                  <ol>
                    <li>No responsibility for third-party hardware.</li>
                    <li>Accuracy depends on hardware/software.</li>
                    <li>No responsibility for misuse or damages.</li>
                  </ol>
                </li>
                <li>
                  <strong>Power Insights</strong>
                  <ol>
                    <li>No responsibility for third-party IoT devices.</li>
                    <li>Accuracy depends on hardware/software.</li>
                    <li>User must provide reasonable support.</li>
                  </ol>
                </li>
                <li>All Services are provided on an “as is” basis.</li>
              </ol>
            </li>

            <li>
              <h2>Access to the Platform</h2>
              <ol>
                <li>User must be competent to contract.</li>
                <li>Access may be restricted or terminated for violations.</li>
                <li>Account registration is mandatory.</li>
              </ol>
            </li>

            <li>
              <h2>Registration</h2>
              <ol>
                <li>Accurate and complete information is required.</li>
                <li>Personal data will be processed lawfully.</li>
                <li>User is responsible for information accuracy.</li>
                <li>Accounts may be suspended or terminated.</li>
                <li>Users are responsible for account security.</li>
              </ol>
            </li>

            <li>
              <h2>Acceptable Use</h2>
              <ol>
                <li>Limited, non-transferable right to use the Platform.</li>
                <li>No obligation to continuously provide Services.</li>
                <li>Users must not misuse the Platform.</li>
                <li>Violations may be investigated.</li>
              </ol>
            </li>

            <li>
              <h2>Payments and Refunds</h2>
              <ol>
                <li>Charges depend on Services availed.</li>
                <li>Payments may be processed via third parties.</li>
                <li>Now Purchase is not a payment intermediary.</li>
                <li>Refunds allowed only in select cases.</li>
              </ol>
            </li>

            <li>
              <h2>Obligations of Users</h2>
              <ol>
                <li>Compliance with internal policies is mandatory.</li>
                <li>Users consent to communications.</li>
                <li>MetalCloud data is confidential.</li>
              </ol>
            </li>

            <li>
              <h2>Data Protection</h2>
              <ol>
                <li>Data collected for Service delivery and analytics.</li>
                <li>Anonymised datasets may be created.</li>
                <li>Users may withdraw consent.</li>
              </ol>
            </li>

            <li>
              <h2>Intellectual Property</h2>
              <ol>
                <li>All IP belongs to Now Purchase.</li>
                <li>Third-party IP remains with owners.</li>
                <li>No ownership rights are transferred.</li>
              </ol>
            </li>

            <li>
              <h2>Indemnification and Limitation of Liability</h2>
              <ol>
                <li>No liability for indirect or consequential damages.</li>
                <li>Liability capped at fees paid.</li>
                <li>Users indemnify Now Purchase.</li>
              </ol>
            </li>

            <li>
              <h2>Disclaimers</h2>
              <ol>
                <li>Services provided on an “as is” basis.</li>
                <li>No liability for AI-based insights.</li>
                <li>No liability for cyber risks.</li>
              </ol>
            </li>

            <li>
              <h2>Miscellaneous</h2>
              <ol>
                <li>Force Majeure applies.</li>
                <li>Governing law: India; jurisdiction: Kolkata.</li>
                <li>Terms survive termination.</li>
                <li>Injunctive relief available.</li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
    </section>
  );
}

export default TermsConditions;
